export class TableAuditModel {
    constructor(FieldName, NewValue, OldValue, PK, TableName, Type, UpdateDate, UserName ) { 
      this.FieldName = FieldName;
      this.NewValue = NewValue;
      this.OldValue = OldValue;
      this.PK = PK;
      this.TableName = TableName;
      this.Type = Type;
      this.UpdateDate = UpdateDate;
      this.UserName = UserName;
    }
  
    fromObject(objectdata) {
      const { FieldName, NewValue, OldValue, PK, TableName, Type, UpdateDate, UserName } = objectdata;
      return new TableAuditModel( FieldName, NewValue, OldValue, PK, TableName, Type, UpdateDate, UserName );
    }
    
    fromArray(arraydata) {
      return arraydata.map(a => {
        const { FieldName, NewValue, OldValue, PK, TableName, Type, UpdateDate, UserName } = a;
        return new TableAuditModel( FieldName, NewValue, OldValue, PK, TableName, Type, UpdateDate, UserName );
      })
    }
  }
  